import { env } from "config/env";

export enum ProductId {
  Audiencias = "audiencias",
  Inquerito = "inquerito",
  Cartorio = "cartorio",
}

export function getCurrentProduct(): string {
  return env.PRODUCT_ID;
}

export function isProduct(productId: ProductId): boolean {
  return env.PRODUCT_ID === productId;
}
